import { styled } from '@ori-ui/mui';
import type { FC } from 'react';

import { BurgerMenuToggle } from './BurgerMenu/BurgerMenuToggle';
import { OriflameLogo } from './OriflameLogo';

const LeftActionsSectionRoot = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',

  [theme.breakpoints.up('sm')]: {
    maxWidth: 'none',
  },
}));

export const LeftActionsSection: FC = () => (
  <LeftActionsSectionRoot>
    <BurgerMenuToggle />
    <OriflameLogo />
  </LeftActionsSectionRoot>
);
